module.exports = __webpack_public_path__ + "static/img/center-title.9770d4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/login/center-title.png
// module id = +cgx
// module chunks = 62